<template>
  <button v-on:click="null" class="social-login-button" :style="cssProps">
    <fa class="icon" :icon="['fab', icon]" :iconColor="iconColor" />
    <p class="button-text">{{ text }}</p>
  </button>
</template>

<script>
export default {
  name: "SocialLogin",
  props: {
    icon: { type: String, default: "null" },
    iconColor: { type: String, default: "black" },
    text: { type: String, default: "pLaCEHoLder TExt" },
  },
  computed: {
    cssProps() {
      if (this.icon === "facebook") {
        return {
          "--icon-color": "var(--" + this.icon,
        };
      } else if (this.icon === "google") {
        let googleColor =
          "var(--" +
          this.icon +
          "-" +
          Math.floor(((Math.random() * 100) % 4) + 1) +
          ")";
        return {
          "--icon-color": googleColor,
        };
      } else {
        return {
          "--icon-color": this.iconColor,
        };
      }
    },
  },
};
</script>

<style scoped>
.social-login-button {
  border: none;

  background: var(--light-clr);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-block: 0.5rem;
  padding-inline: 0.5rem;
  border-radius: 9999rem;
  box-shadow: var(--box-shadow);
  cursor: pointer;
  transition: 0.5s ease;
}

.icon {
  /* color: var(--icon-color); */
  color: var(--primary-clr);
  margin: 0 0.5rem;
  transition: 0.5s ease;
}

.social-login-button:hover,
.social-login-button:focus {
  box-shadow: var(--box-shadow-focus);
  transform: scale(1.01) rotateZ(0deg);
}

.social-login-button:hover .icon,
.social-login-button:focus .icon,
.social-login-button:hover .button-text,
.social-login-button:focus .button-text {
  color: var(--icon-color) !important;
}

.button-text {
  font-weight: bold;
  transition: 0.5s ease;
}
</style>
